module.exports = __webpack_public_path__ + "img/base_patrimoine_cave.9f748148.svg";